
    import QuestionMixin from '@/components/JobView/Apply/Questions/QuestionMixin';
    import C1Upload from '@/C1Components/C1Upload';

    export default {
        name: 'QuestionMultiupload',

        components: {
            C1Upload,
        },

        mixins: [
            QuestionMixin,
        ],

        data() {
            return {
                files: [],
                questionId: `question_multiupload_${this.question.id}`,
            };
        },

        computed: {
            answer() {
                return this.files.map(o => o.id);
            },

            validation() {
                return !!this.answer.length;
            },
        },

        created() {
            if (Array.isArray(this.question.answer)) {
                this.files = this.question.answer.map((o) => {
                    return {
                        id: o,
                    };
                });
            }
        },

        methods: {
            onFileUploaded(file) {
                this.files.push(file);
            },

            onFileDeleted(file) {
                const index = this.files.findIndex(o => o.uuid === file);
                if (index >= 0) {
                    this.files.splice(index, 1);
                }
            },
        },
    };
